<template>
  <div>
    <!-- 菜单切换tabs -->
    <activity-tabs></activity-tabs>
    <div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="formClass"
      >
        <!-- 基本信息 -->
        <div class="divLine"><i class="el-icon-document"></i> 基本信息</div>
        <el-form-item label="活动类型" prop="ActivityTypeIDStr">
          <el-radio-group v-model="ruleForm.ActivityTypeIDStr">
            <el-radio
              v-for="item in activityTypesList"
              :key="item.ActivityTypeIDStr"
              :label="item.ActivityTypeIDStr"
            >
              {{ item.ActivityTypeName }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标题" prop="EA_Title" class="formWidth">
          <el-input
            v-model="ruleForm.EA_Title"
            placeholder="请填写活动标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="活动分类"
          prop="MainCategorIDStr"
          class="formWidth categorGroup"
        >
          <el-radio-group v-model="ruleForm.MainCategorIDStr">
            <el-radio
              v-for="item in activityCategorList"
              :key="item.MainCategorIDStr"
              :label="item.MainCategorIDStr"
            >
              {{ item.EMC_MainTitle }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动时间" prop="formDateTime" class="formWidth">
          <el-date-picker
            v-model="ruleForm.formDateTime"
            type="datetimerange"
            @input="datetimeChange"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            range-separator="至"
            start-placeholder="活动开始日期"
            end-placeholder="活动结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="省份城市" prop="cascaderCity" class="formWidth">
          <el-cascader
            size="large"
            :options="options"
            clearable
            placeholder="请选择省份城市"
            v-model="ruleForm.cascaderCity"
            :props="{ checkStrictly: true, expandTrigger: 'hover' }"
            @change="handleCityChange"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="地址" prop="EAS_CNAddress" class="formWidth">
          <el-input
            v-model="ruleForm.EAS_CNAddress"
            placeholder="如花木路1388号（无需再次填写省份城市）"
          ></el-input>
        </el-form-item>
        <el-form-item label="地点" prop="EAS_CNHostPlace" class="formWidth">
          <el-input
            v-model="ruleForm.EAS_CNHostPlace"
            placeholder="如上海浦东嘉里中心、北京四季酒店等"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动权重" prop="EA_Weight" class="formWidth">
          <el-input
            v-model="ruleForm.EA_Weight"
            placeholder="活动权重"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否收费" prop="EA_Gratis" required="">
          <el-radio-group v-model="ruleForm.EA_Gratis">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否显示卓悦会" prop="EA_Source" required="">
          <el-radio-group v-model="ruleForm.EA_Source">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="是否显示HRoot"
          prop="EA_IsHRootWebShow"
          required=""
        >
          <el-radio-group v-model="ruleForm.EA_IsHRootWebShow">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="现场联络" prop="EA_Contacts" class="formWidth">
          <el-input
            v-model="ruleForm.EA_Contacts"
            placeholder="小王：1371788990，小张：1371788991"
          ></el-input>
        </el-form-item>
        <el-form-item label="签到描述" prop="EA_SignInDesc" class="formWidth">
          <el-input
            v-model="ruleForm.EA_SignInDesc"
            placeholder="携带xxx至x楼签到处签到（签到时间：xx:xx-xx:xx）"
          ></el-input>
        </el-form-item>

        <!-- 活动内容 -->
        <div class="divLine"><i class="el-icon-document"></i> 活动内容</div>
        <el-form-item prop="EA_Imgs" label="EDM">
          <div style="display: flex; align-items: center">
            <div v-if="ruleForm.EA_Imgs">
              <img
                class="picImgEDM"
                :src="
                  ruleForm.EA_Imgs +
                  '?x-oss-process=image/resize,h_162,w_152,m_fixed'
                "
              />
            </div>
            <div class="editor-custom-btn-container">
              <UploadPan
                ref="upload"
                v-model="fileListEDM"
                :form="form"
                class="editor-upload-btn"
                :model="model"
                @on-close="handleCloseUploadEDM"
                @on-update="handleOnUpdateEDM"
                :accept="accept"
                color="#1890ff"
              />
              <span style="font-size: 12px">宽640（像素）*高600（像素）</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="EA_Img2" label="封面图片">
          <div style="display: flex; align-items: center">
            <div v-if="ruleForm.EA_Img2">
              <img
                class="picImg"
                :src="
                  ruleForm.EA_Img2 +
                  '?x-oss-process=image/resize,h_102,w_202,m_fixed'
                "
              />
            </div>
            <div class="editor-custom-btn-container">
              <UploadPan
                ref="upload"
                v-model="fileList"
                :form="form"
                class="editor-upload-btn"
                :model="model"
                @on-close="handleCloseUpload"
                @on-update="handleOnUpdate"
                :accept="accept"
                color="#1890ff"
              />
              <span style="font-size: 12px">宽1000（像素）*高500（像素）</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="EA_Content" label="活动描述">
          <Tinymce
            ref="descTinymce"
            v-model="ruleForm.EA_Content"
            :accept="accept"
            :form="form"
            :model="model"
            style="width: 90%"
          ></Tinymce>
        </el-form-item>
        <!-- 模板选择 -->
        <div class="divLine">
          <i class="el-icon-document"></i> 模板选择
          <el-button
            class="addTickets"
            type="primary"
            size="small"
            :disabled="ruleForm.TemplateRelations.length >= tempTypes.length"
            @click="addTemplate"
            >添加模板类型</el-button
          >
        </div>
        <template v-if="ruleForm.TemplateRelations.length > 0">
          <el-form-item
            label="模板类型"
            v-for="item in ruleForm.TemplateRelations"
            :key="item.key"
            class="ticketsInput"
          >
            <el-col :span="4">
              <el-select
                v-model="item.ET_Type"
                placeholder="请选择模板类型"
                @change="templateTypeChange($event, item)"
              >
                <el-option label="请选择模板类型" :value="-1"></el-option>
                <el-option
                  v-for="io in tempTypes"
                  :label="io.Name"
                  :value="io.Value"
                  :key="io.Value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="7" class="slectTemp">
              <el-select
                v-model="item.TemplateIDStr"
                placeholder="邮件模板"
                @visible-change="templateVisibleChange($event, item)"
              >
                <el-option label="请选择邮件模板" value=""></el-option>
                <el-option
                  v-for="io in ActNotTempList"
                  :label="io.ET_Name"
                  :value="io.TemplateIDStr"
                  :key="io.TemplateIDStr"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-select v-model="item.SmsSignName" placeholder="短信签名">
                <el-option label="请选择短信签名" value=""></el-option>
                <el-option
                  v-for="io in SmsSignlist"
                  :label="io.SignName"
                  :value="io.SignName"
                  :key="io.SignName"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select
                v-model="item.SmsCode"
                placeholder="短信模板"
                @change="smsCodeChange($event, item)"
              >
                <el-option label="请选择短信模板" value=""></el-option>
                <el-option
                  v-for="io in SmsTemplatelist"
                  :label="io.TemplateName"
                  :value="io.TemplateCode"
                  :key="io.TemplateCode"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-button @click.prevent="removeTemplate(item)">删除</el-button>
            </el-col>
          </el-form-item>
        </template>
        <template v-else>
          <h2 class="noTemplate">暂无模板</h2>
        </template>

        <!-- 门票类型 -->
        <div class="divLine" v-if="ruleForm.EA_Gratis === 1">
          <i class="el-icon-document"></i> 门票类型
          <el-button
            class="addTickets"
            type="primary"
            size="small"
            @click="addTickets"
            >添加门票类型</el-button
          >
        </div>
        <template v-if="ruleForm.EA_Gratis === 1">
          <el-form-item
            label="门票类型"
            v-for="item in ruleForm.ActivityTickets"
            :key="item.key"
            class="ticketsInput"
          >
            <el-col :span="7">
              <el-input
                class="ticketType"
                v-model="item.EAT_TicketsName"
                placeholder="门票类型（普通门票）"
              ></el-input>
            </el-col>
            <el-col :span="5">
              <el-input
                class="ticketPrice"
                v-model.number="item.EAT_TicketsPrice"
                placeholder="门票费用（RMB）"
                maxlength="8"
              ></el-input>
            </el-col>
            <el-col :span="6">
              <el-input
                class="ticketRemark"
                v-model="item.EAT_Remarks"
                placeholder="门票备注"
              ></el-input>
            </el-col>
            <el-col :span="6">
              <el-button @click.prevent="removeTickets(item)">删除</el-button>
            </el-col>
          </el-form-item>
        </template>
        <el-form-item class="postSubmitForm">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  getActivityInfo,
  getActivityTypes,
  getActivityCategorList,
  addOrUpdctivity,
  getTemplateTypes,
  GetTemplateListByType,
  GetTemplateListByActivityId,
  getSmsSignlist,
  getSmsTemplatelist,
} from '../../api/api'
import ActivityTabs from '@/components/ActivityTabs.vue'
import store from '@/store'
import UploadPan from '@/components/Upload/index'
import Tinymce from '@/components/Tinymce/index'
import { codeToText, provinceAndCityData } from 'element-china-area-data'
export default {
  name: 'addUpd',
  data() {
    return {
      options: provinceAndCityData, // 城市联动数据
      activityTypesList: [], // 活动类型
      activityCategorList: [], // 活动分类
      ruleForm: {
        ActivityTypeIDStr: '', // 活动类型
        EA_Title: '', //活动标题
        MainCategorIDStr: '', // 活动分类
        EAS_StartTime: '', // 开始 时间
        EAS_EndTime: '', // 结束 时间
        formDateTime: '', // 活动时间
        EAS_ProvinceName: '', //省份
        EAS_CityName: '', //城市
        EAS_CNProvinces: '', // 省份编码
        cascaderCity: [], // 城市
        EAS_CNCity: '', // 城市编码
        EAS_CNAddress: '', // 地址
        EAS_CNHostPlace: '', // 地点
        EA_Weight: 0, // 权重
        EA_Gratis: 0, // 是否收费
        EA_Source: 0, //是否卓悦会
        EA_IsHRootWebShow: 1, //是否HRoot官网显示
        EA_Contacts: '', //现场联络
        EA_SignInDesc: '', //签到描述
        EA_Img2: '', // 封面图片
        EA_Imgs: '', // EDM图片
        EA_Content: '', // 介绍
        // 模板
        TemplateRelations: [],
        // 门票类型
        ActivityTickets: [],
      },
      tempTypes: [], // 模板类型
      ActNotTempList: [], // 根据类型ID获取模板列表
      SmsSignlist: [], // 短信签名列表
      SmsTemplatelist: [], // 短信模板列表
      rules: {
        ActivityTypeIDStr: [
          { required: true, message: '请选择活动类型', trigger: 'change' },
        ],
        EA_Title: [
          { required: true, message: '请输入活动标题', trigger: 'blur' },
        ],
        MainCategorIDStr: [
          { required: true, message: '请选择活动分类', trigger: 'change' },
        ],
        formDateTime: [
          { required: true, message: '请选择活动时间', trigger: 'change' },
        ],
        cascaderCity: [
          { required: true, message: '请选择活动省份城市', trigger: 'change' },
        ],
        EAS_CNAddress: [
          { required: true, message: '请输入活动地址', trigger: 'blur' },
        ],
        EAS_CNHostPlace: [
          { required: true, message: '请输入活动地点', trigger: 'blur' },
        ],
        EA_Img2: [
          {
            required: true,
            message: '请上传封面图片',
            trigger: ['change', 'blur'],
          },
        ],
        EA_Imgs: [
          {
            required: true,
            message: '请上传EDM图片',
            trigger: ['change', 'blur'],
          },
        ],
        EA_Content: [
          { required: true, message: '请输入活动描述', trigger: 'change' },
        ],
      },
      fileList: [],
      fileListEDM: [],
      model: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept: '.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PBG,.GIF',
      filters: {
        ET_Name: '',
        ET_Type: -1,
      },
    }
  },
  components: {
    ActivityTabs,
    UploadPan,
    Tinymce,
  },
  methods: {
    // 根据活动ID查询活动信息
    hadnleQuery() {
      if (store.getters.getCurActivityId === '0') {
      } else {
        getActivityInfo(store.getters.getCurActivityId).then((res) => {
          if (res.data.success) {
            this.ruleForm = res.data.response
            this.ruleForm.formDateTime = [
              res.data.response.EAS_StartTime,
              res.data.response.EAS_EndTime,
            ]
            this.ruleForm.cascaderCity = res.data.response.EAS_CNCity
          } else {
            this.$message({
              message: '非正常访问',
              type: 'error',
            })
          }
        })
      }
    },
    // 切换城市联动
    handleCityChange(value) {
      if (this.ruleForm.cascaderCity.length > 1) {
        this.ruleForm.EAS_ProvinceName = this.ruleForm.cascaderCity[0]
        this.ruleForm.EAS_CNCity = this.ruleForm.cascaderCity[1]
        this.ruleForm.EAS_CityName = codeToText[this.ruleForm.cascaderCity[1]]
      } else {
        this.ruleForm.EAS_CNCity = this.ruleForm.cascaderCity[0]
        this.ruleForm.EAS_CityName = codeToText[this.ruleForm.cascaderCity[0]]
      }
    },

    // 添加门票类型
    addTickets() {
      this.ruleForm.ActivityTickets.push({
        EAT_TicketsName: '',
        key: Date.now(),
      })
    },
    // 删除门票类型
    removeTickets(item) {
      var index = this.ruleForm.ActivityTickets.indexOf(item)
      if (index !== -1) {
        this.ruleForm.ActivityTickets.splice(index, 1)
      }
    },

    // 添加模板类型
    addTemplate() {
      var isNotComplated = this.ruleForm.TemplateRelations.some(
        (item) => !item.SmsSignName && !item.TemplateIDStr
      )
      if (isNotComplated) {
        this.$message({
          message: '请先完善上一条模板信息',
          type: 'error',
        })
      } else {
        this.ruleForm.TemplateRelations.push({
          ET_Type: -1,
          TemplateIDStr: '',
          ET_Name: '',
          SmsCode: '',
          SmsSignName: '',
        })
      }
    },
    templateTypeChange(event, param) {
      var temps = this.ruleForm.TemplateRelations.filter((item) => {
        return item.ET_Type == event
      })
      this.ActNotTempList = []
      GetTemplateListByType(event).then((res) => {
        if (res.data.success) {
          this.ActNotTempList = res.data.response.data
        }
      })
      if (temps.length > 1) {
        param.ET_Type = -1
        this.$message({
          message: '请添加其它模板类型',
          type: 'error',
        })
      }
    },
    templateVisibleChange(event, param) {
      if (param.ET_Type == -1) {
        this.$message({
          message: '请先选择模板类型',
          type: 'error',
        })
      } else {
        if (event) {
          this.ActNotTempList = []
          GetTemplateListByType(param.ET_Type).then((res) => {
            if (res.data.success) {
              this.ActNotTempList = res.data.response
            }
          })
        }
      }
    },
    smsCodeChange(event, param) {
      if (!param.SmsSignName) {
        param.SmsCode = ''
        this.$message({
          message: '请先选择短信签名',
          type: 'error',
        })
      }
    },
    // 删除模板类型
    removeTemplate(item) {
      var index = this.ruleForm.TemplateRelations.indexOf(item)
      if (index !== -1) {
        this.ruleForm.TemplateRelations.splice(index, 1)
      }
    },
    datetimeChange(val) {
      this.$nextTick(() => {
        this.$set(this.ruleForm, 'formDateTime', [val[0], val[1]])
        this.$forceUpdate()
      })
    },
    submitForm(formName) {
      var isNotComplated = this.ruleForm.TemplateRelations.some(
        (item) => !item.SmsCode && !item.TemplateIDStr
      )
      if (isNotComplated) {
        this.$message({
          message: '请完善模板信息',
          type: 'error',
        })
        return
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.EA_Gratis === 1) {
            if (this.ruleForm.ActivityTickets.length > 0) {
            } else {
              this.$message({
                message: '请添加门票类型',
                type: 'error',
              })
              return
            }
          }
          this.ruleForm.EAS_StartTime = this.ruleForm.formDateTime[0]
          this.ruleForm.EAS_EndTime = this.ruleForm.formDateTime[1]
          addOrUpdctivity(this.ruleForm).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.$router.push(`/DetpActivity/Activity`)
            } else {
              this.$message({
                message: '操作失败！',
                type: 'error',
              })
              return
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    handleCloseUpload() {
      this.fileList = []
    },
    handleOnUpdate(obj) {
      // ?x-oss-process=image/resize,h_160,w_130,m_fixed
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      this.ruleForm.EA_Img2 = url
    },
    handleCloseUploadEDM() {
      this.fileListEDM = []
    },
    handleOnUpdateEDM(obj) {
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      this.ruleForm.EA_Imgs = url
    },
    // 活动类型
    getActivityTypes() {
      getActivityTypes().then((res) => {
        // console.log('活动类型', res)
        if (res.data.success) {
          this.activityTypesList = res.data.response
        }
      })
    },

    // 活动分类
    getActivityCategorList() {
      getActivityCategorList().then((res) => {
        // console.log('活动分类', res)
        if (res.data.success) {
          this.activityCategorList = res.data.response
        }
      })
    },

    // 根据类型ID选择邮件模板
    getTempList() {
      // 获取模板类型
      getTemplateTypes().then((res) => {
        if (res.data.success) {
          this.tempTypes = res.data.response
        }
      })

      GetTemplateListByActivityId(store.getters.getCurActivityId).then(
        (res) => {
          if (res.data.success) {
            this.ActNotTempList = res.data.response
          }
        }
      )

      getSmsSignlist().then((res) => {
        if (res.data.success) {
          this.SmsSignlist = res.data.response
        }
      })
      getSmsTemplatelist().then((res) => {
        if (res.data.success) {
          this.SmsTemplatelist = res.data.response
        }
      })
    },
  },
  mounted() {
    this.hadnleQuery()
    this.getActivityTypes()
    this.getActivityCategorList()

    this.getTempList()

    // console.log(store.getters.getCurActivityId)
  },
}
</script>

<style scoped>
.actTabs div.xbxx {
  background: #fff;
  border-bottom: 0;
}
.formClass {
  padding-bottom: 20px;
}
.divLine {
  border-bottom: 2px solid #00623b;
  line-height: 30px;
  font-size: 16px;
  color: #00623b;
  margin-bottom: 20px;
  padding-bottom: 10px;
}
.divLine i {
  font-size: 20px;
}
.categorGroup .el-radio {
  line-height: 2;
}
.picImg {
  width: 200px;
  height: 100px;
  background-color: red;
  border: 1px solid grey;
}
.picImgEDM {
  width: 150px;
  height: 160px;
  background-color: red;
  border: 1px solid grey;
}
.picImg,
.picImgEDM {
  margin-right: 30px;
}
.editor-custom-btn-container {
  display: flex;
}
.editor-custom-btn-container span {
  margin-left: 20px;
  color: #666;
}
.formWidth .el-input,
.formWidth .el-select,
.formWidth .el-date-editor,
.formWidth .el-cascader {
  width: 55%;
}
.formWidth .el-radio-group {
  width: 65%;
}
.slectTemp .el-select {
  width: 100%;
}
.addTickets.el-button {
  margin-left: 50px;
}
.el-form-item .el-form-item.ticketsInput {
  margin-bottom: 15px;
}
.ticketsInput .el-col {
  padding-right: 20px;
}
.postSubmitForm {
  position: absolute;
  bottom: 100px;
  right: 50px;
}
.postSubmitForm .el-button span {
  font-size: 16px !important;
}
.noTemplate {
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  margin-bottom: 50px;
  color: #606266;
}
</style>
